import React from 'react';
import { usePageData } from '../../contexts/DataContext';
import LoadingSpinner, { LoadingSkeleton } from '../common/LoadingSpinner';

const AboutSection = () => {
  const { data: aboutPage, isLoading, error } = usePageData('aboutPage');

  if (isLoading) {
    return (
      <section className="about-section">
        <div className="container">
          <LoadingSkeleton type="text" count={2} />
          {[...Array(3)].map((_, i) => (
            <div className="about-item" key={i}>
              <LoadingSkeleton type="text" count={3} />
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (error || !aboutPage || !aboutPage.blocks) {
    return (
      <section className="about-section">
        <div className="container">
          <h2>About Resumeslip</h2>
          <p className="subtitle">Lorem ipsum dolor sit amet, consectetur adipiscing elit</p>

          {[1, 2, 3].map((i) => (
            <div className="about-item" key={i}>
              <h3>About Item {i}</h3>
              <div className="underline"></div>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit...</p>
            </div>
          ))}
        </div>
      </section>
    );
  }

  return (
    <section className="about-section">
      <div className="container">
        <h2>{aboutPage.about_title}</h2>
        <p className="subtitle">{aboutPage.about_subtitle}</p>

        {aboutPage.blocks.map((block, index) => (
          <div className="about-item" key={index}>
            <h3>{block.title}</h3>
            <div className="underline"></div>
            <div dangerouslySetInnerHTML={{ __html: block.content }} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default AboutSection;